export const ANO_MINIMO_PONTUACAO = 2026;

export function normalizarDataLocal(valor: string | Date): Date {
  if (typeof valor === 'string') {
    const data = valor.includes('T') ? new Date(valor) : new Date(`${valor}T00:00:00`);
    data.setHours(0, 0, 0, 0);
    return data;
  }
  const data = new Date(valor);
  data.setHours(0, 0, 0, 0);
  return data;
}

export function getAnoLetivoAtual(): number {
  return new Date().getFullYear();
}

export function getInicioPeriodoLetivo(anoLetivo = getAnoLetivoAtual()): Date {
  return new Date(anoLetivo, 0, 1);
}

export function getInicioMesVigente(referencia = new Date()): Date {
  const ref = normalizarDataLocal(referencia);
  return new Date(ref.getFullYear(), ref.getMonth(), 1);
}

export function getDataMaximaFato(referencia = new Date()): Date {
  return normalizarDataLocal(referencia);
}

export function getDataMinimaCadastroFato(anoLetivo = getAnoLetivoAtual(), referencia = new Date()): Date {
  const candidatos = [
    getInicioPeriodoLetivo(anoLetivo),
    new Date(ANO_MINIMO_PONTUACAO, 0, 1),
    getInicioMesVigente(referencia),
  ];
  return new Date(Math.max(...candidatos.map(d => d.getTime())));
}

export function formatarDataIsoLocal(data: Date): string {
  const y = data.getFullYear();
  const m = String(data.getMonth() + 1).padStart(2, '0');
  const day = String(data.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function isMesmaCompetenciaCivil(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();
}

export function podeEditarOuExcluirRegistro(dataInclusao: string | Date, referencia = new Date()): boolean {
  const inclusao = normalizarDataLocal(dataInclusao);
  const hoje = getDataMaximaFato(referencia);
  return isMesmaCompetenciaCivil(inclusao, hoje);
}

export function validarDataFatoCadastro(dataFato: string | Date, anoLetivo = getAnoLetivoAtual(), referencia = new Date()): string | null {
  const data = normalizarDataLocal(dataFato);
  const hoje = getDataMaximaFato(referencia);
  const min = getDataMinimaCadastroFato(anoLetivo, referencia);

  if (data.getFullYear() < ANO_MINIMO_PONTUACAO) {
    return `Não é permitido registrar pontuação para anos anteriores a ${ANO_MINIMO_PONTUACAO}.`;
  }

  if (data < getInicioPeriodoLetivo(anoLetivo)) {
    return 'A data do fato deve pertencer ao período letivo atual.';
  }

  if (data < min) {
    return 'A data do fato deve estar no mês vigente.';
  }

  if (data > hoje) {
    return 'A data do fato não pode ser superior à data atual.';
  }

  if (!isMesmaCompetenciaCivil(data, hoje)) {
    return 'Só é permitido adicionar pontuação para o mês vigente.';
  }

  return null;
}
